<footer class="footer-wrap mt-5 mb-3">
  <div class="text-center d-flex justify-content-center align-items-center">
    <button class="prevbtn d-flex align-items-center gap-2">
      <img src="../../../../assets/images/previous-icon.svg" alt="" /> Back to Master frame
    </button>
  </div>
</footer>
